import { emailSuggestion } from "@/lib/emailTypo";

export const EmailTypoHint = ({ email, onFix, testId = "email-typo-hint" }) => {
  const s = emailSuggestion(email);
  if (!s) return null;
  return (
    <p data-testid={testId} className="text-xs text-amber-700 dark:text-amber-400">
      Check the spelling: did you mean <strong>@{s.domain}</strong>?{" "}
      <button type="button" data-testid={`${testId}-use-btn`} onClick={() => onFix(s.email)} className="underline font-semibold">Use @{s.domain}</button>
    </p>
  );
};
